import React, {useRef, useEffect, useState, useMemo, useCallback} from 'react';
import styles from './LandingVideo.module.scss'
import {useDispatch, useSelector} from "react-redux";
import gsap from "gsap";
import {buttonClick} from "utils/Helpers";
import Play from "components/icons/play/Play";
import NavToggle from "components/icons/navToggle/NavToggle";

const LandingVideo = (props) => {

    const video = useMemo(()=> {return {
        portrait: {
            bgUrl: `https://msobd-storage.azureedge.net/videos/Anthem_bg_9x16.mp4`,
            fullUrl: `https://msobd-storage.azureedge.net/videos/anthem_9x16.mp4`,
        },
        landscape: {
            bgUrl:`https://msobd-storage.azureedge.net/videos/Anthem_bg_16x9.mp4`,
            fullUrl:`https://msobd-storage.azureedge.net/videos/anthem_16x9.mp4`,
        }
    }},[]);

    const accessible = useSelector(state => state.accessible);
    const panelData = useSelector(state => state.panelData);
    const windowData = useSelector(state => state.window);
    const dispatch = useDispatch();
    const videoGroup = useRef();
    const [videoSrc, setVideoSrc] = useState(windowData.width <= 767 ? video.portrait : video.landscape);
    const currentVideo = useRef();
    const player = useRef();
    const [fullscreen, setFullscreen] = useState(false);

    const [playActivated, setPlayActivated] = useState(false);
    const videoInitialized = useRef(false);

    useEffect(()=>{
        dispatch({ type: "NEW_ASSET", payload: './videos/video.mp4' });
    },[dispatch, props.set])

    function loaded(){
        dispatch({ type: "ASSET_LOADED", payload: './videos/video.mp4' });
    }

    useEffect(()=>{

        let touchStart = () => {
            if(player.current){
                setPlayActivated(true)
                player.current.play();
                window.removeEventListener('touchstart', touchStart)
            }
        }

        window.addEventListener('touchstart', touchStart)

    }, [])

    function isPlaying(){
        setPlayActivated(true)
    }

    useEffect(()=>{

        if(panelData.stackOrder.logo === 'active' || panelData.stackOrder.introText === 'active' ){
            if(videoInitialized.current) player.current.play();
            gsap.to(videoGroup.current, {opacity: 1})
        } else {
            player.current.pause();
            setTimeout(()=>player.current.currentTime = 0 ,2000)
            gsap.to(videoGroup.current, {opacity: 0, delay: 1})
        }

        videoInitialized.current = true;

    },[panelData])

   function toggleFullscreen(){
       dispatch({ type: "SET_ACCESSIBLE",
           payload: {
               ...accessible,
               videoActive: !fullscreen,
               landingVideoModal: !fullscreen
           }
       });
       setFullscreen(!fullscreen);
   }

   useEffect(()=>{

       if(fullscreen){
           player.current.pause();
       } else {
           player.current.play();

       }

   }, [fullscreen, accessible, dispatch])

    function displayFullScreen(){

        let hidden = (!accessible.siteEntered && panelData.stackOrder.introText === 'active' && !accessible.modalOpen) || panelData.stackOrder.introText !== 'active';
        
        let attrs = hidden ? {} : {
            tabIndex: 0,
            role:'button',
            'aria-label': 'Full Screen Toggle',
            onKeyDown: (e)=>buttonClick(e),
            onClick: toggleFullscreen
        }

        return (
            <>
                <div {...attrs} className={styles.play}>
                    Watch <Play/>
                </div>

            </>
        )
    }

    useEffect(()=>{
        if(windowData.width <= 767){
            if(currentVideo.current !== video.portrait) setVideoSrc(video.portrait)
        } else {
            if(videoSrc !== video.landscape) setVideoSrc(video.landscape)
        }
    }, [windowData, videoSrc,  setVideoSrc, video])

    const setVolume = useCallback((node)=>{
        if(node) node.volume = 0.3;
    }, [])

    return (
        <>
            <div ref={videoGroup} className={`landingVideo ${styles.videoWrapper}`} style={{zIndex:props.zIndex}}>
                <div className={styles.videoObject}>

                    {displayFullScreen()}

                    {!playActivated && <div className={styles.static}/>}

                    <video aria-hidden={!accessible.siteEntered} aria-label={'Original by Design, Anthem Video'} muted={true} autoPlay loop={true} controls={false} onLoadedMetadata={loaded} ref={player} className={`${styles.videoPlayer} landingPlayer`}
                           playsInline autobuffer={'true'} onPlaying={isPlaying}>
                        <source src={videoSrc.bgUrl} type="video/mp4"/>
                    </video>

                </div>
            </div>

            {fullscreen && (
                <div className={styles.videoOverlay}>
                        <span tabIndex={0} role={'button'} onKeyDown={buttonClick} aria-label={'Close manage cookies modal'} className={styles.close} onClick={toggleFullscreen}>
                            <NavToggle menuOpen={true} closeOnly={true} dark={true}/>
                        </span>
                    <video aria-hidden={fullscreen} style={{pointerEvents: !fullscreen ? 'none' : 'auto' }} playsInline={true} autoPlay={true}
                           aria-label={'Original by Design, Anthem Video'} controls={true} ref={setVolume}
                           className={`${styles.fullPlayer} `}
                           autobuffer={'true'} width={'100%'} height={'auto'}>
                        <source src={videoSrc.fullUrl} type="video/mp4"/>
                        <track label="English" kind="subtitles" srcLang="en" src={'video/anthem.vtt'}/>
                    </video>
                </div>
                )

            }
        </>
    )
};

export default LandingVideo
